import React, { useEffect } from "react";

const CookieYes = () => {

    useEffect(() => {
        const script = document.createElement('script');

        script.id = "cookieyes"
        script.type = "text/javascript"
        script.src = "https://cdn-cookieyes.com/client_data/c4b2263b317b07cde8d126298b0bbdc1/script.js"

        document.head.appendChild(script);

    }, [])

    return (
        <></>
    )
}

export default CookieYes
